
/* ATTENTION!
This file is automatically generated by scripts/set-env.ts
Please do not change or commit it
*/
import { IEnvironment } from '@skychute/ui-models';
function isEqual(a: any, b: any): boolean {
    return a === b;
}
export const config: IEnvironment = {
    production: isEqual('true', 'true'),
    services: {
        data: {
          endpoint: 'https://development-hasura.projectre.com.au',
          path: '/v1/graphql',
          logQueries: 'false'
        },
        aws: {
          UserPoolId: 'ap-southeast-2_XnYMQLsHj',
          AppClientId: '5ip9f507akh1n1mjs5fguhhg7e',
          cloudUri: 'https://cm58gdi825.execute-api.ap-southeast-2.amazonaws.com/dev',
        },
        analytics: {
            segment: {
                enabled: isEqual('false', 'true'),
                writeKey: 'CKazVWLN9swSOQAxq5aOOuUzu9MFuARF',
            },
        },
    },
    application: {
        version: '1.187.1',
        gitHead: '12de877ed966429a71a1efd5739c87ba5232ed2e',
        branch: 'development',
        buildDate: 'November 2nd 2026, 11:01:00 pm',
        buildNumber: '1650',
    },
    stripe: {
        publicKey: 'pk_test_51JVQJzICXqe0hIJdVHDRyFoCVJbQwhWPayB7eHg1boYOy7FsCv7Sj1CJSYA2u6vPj4zRNbmsR6tsVu48e0yQEhYT00ycLtgphf'
    },
    addressFinder: {
        key: 'RBHCYUV987D4XKNPT6FL',
        src: 'https://api.addressfinder.io/assets/v3/widget.js'
    },
    courier_push_client_key:'ODM2OTc0NWItODA5NS00OTI3LWE1ZTEtMWI0OGEyZjBkNjg0L3Rlc3Q=',
    recaptcha_v3_site_key:'6LcmCVosAAAAAKHMw_lrGdsTChgK-IQ1L-cIlxV9',
    novu_push_client_key:'GVO-2E8_6qNx',
    link_private_endpoint:'https://development-linkprivate.projectredev.dev.skychute.com.au',
};
